import { policyConfig } from "shared";
import { When } from "react-if";

import { fieldIsValid } from "../../../../../lib/helper";
import { Toggle } from "../../../../../../common/Atoms/Toggle";
import { useSettings } from "../../../../../hooks/useSettings";
import { Notification } from "../../../../../../common/Atoms/Notification";

import { IFieldProps } from "./fieldProps";

const config = policyConfig[`only_send_to_primary_contact`];

export function OnlySendToPrimaryContact({
  policyFormData,
  invalids,
  handleChange,
}: IFieldProps) {
  const { data: settings } = useSettings();

  return (
    <div>
      <Toggle
        label={ config.label }
        description={ `Only send this email to the primary contact` }
        checked={ policyFormData.only_send_to_primary_contact || false }
        onChange={ handleChange }
        invalid={ fieldIsValid(`only_send_to_primary_contact`, invalids) }
        name={ `only_send_to_primary_contact` }
      />

      <When condition={ settings?.onlySendPrimaryContact }>
        <Notification
          type={ `warning` }
        >
          { `The organisation setting "Only send to primary contact" is enabled, so this setting will have no effect.` }
        </Notification>
      </When>
    </div>
  );
}
